export const getJsonData = (dataType) => {
    if (dataType === 'jsonData211') {
        return [
            { key: 1, name: '客房總覽 – 北投加賀屋' },
            { key: 2, name: '踏進大廳的第一秒，幽微的薰香即染上衣角，洗去旅途的奔波；耳邊繚繞的和風音韻，帶來一絲他方的絮語。榻榻米的暖香，為呼吸融入自然氣息；筆直的牆柱削去了直角，是內化於心的溫柔；一扇扇門扉屏蔽的空間，或曲折或寬敞，都是視覺的驚喜。完美的旅行，從北投加賀屋開始。' }
        ];
    }
    else if (dataType === 'jsonData212') {
        return [
            { key: 1, name: '優惠住房專案 [線上訂房]' }
        ];
    }
    else if (dataType === 'jsonData213') {
        return [
            { key: 1, name: '查詢訂房結果' }
        ];
    }
    else if (dataType === 'jsonData221-1') {
        return [            
            { key: 1, name:'4F 白磺大眾湯'},
            { key: 2, name: '大眾湯 (白磺美人湯)，採現場登記候位。' }
        ];
    }
    else if (dataType === 'jsonData221-2') {
        return [
            { key: 1, name: '5F 雙人獨立湯屋' },
            { key: 2, name: '雙人獨立湯屋 (白磺美人湯)，採網路預約。' }
        ];
    }
    else if (dataType === 'jsonData222') {
        return [
            { key: 1, name: '7F 北投石檜木岩盤浴（乾式溫泉）' },
            { key: 2, name: '岩盤浴 (珍稀北投石)，採電話預約。' }
        ];
    }
    else if (dataType === 'jsonData223') {
        return [
            { key: 1, name: 'The Spa by Socié ' },
            { key: 2, name: 'SPA日本頂級 The Spa by Socié，採電話預約。' }
        ];
    }
    else if (dataType === 'jsonData231') {
        return [
            { key: 1, name: '天翔廳 - 自助式早餐/日本會席料理' },
            { key: 2, name: '料理職人嚴選當令食材，演繹日本和食料理極致美學，以精緻佳餚滿足挑剔的味蕾,享受獨樹一格的料理美饌。 料理遵循日本「旬」食原則，旬（しゅん），漢字是「當令」的意思，依旬而食，品味季節之美。 嚴選日本、台灣當季新鮮食材製作的會席料理，體驗正宗大和食之雅韻；或品嚐精緻自助式早餐，一邊欣賞北投公園綠景，怡然自得，滿足對極致休憩的渴望。' }
        ];
    }
    else if (dataType === 'jsonData232') {
        return [
            { key: 1, name: '日和廳 – 咖啡廳' },
            { key: 2, name: '坐擁北投綠意，在舒適的氛圍中可悠然於此享用精緻小點、蛋糕茶點和各式飲品，另有販售精美伴手禮，歡迎參觀選購！' }
        ];
    }
    else if (dataType === 'jsonData233') {
        return [
            { key: 1, name: '夕月BAR' },
            { key: 2, name: '供應豐富的日本藏酒、多款異國精選佳釀和特調，讓您度過愜意的夜晚時分。' }
        ];
    }
    else if (dataType === 'jsonData241') {
        return [
            { key: 1, name: '宴會廳介紹' },
            { key: 2, name: '北投加賀屋館內的宴會廳有日式榻榻米/西式地毯型宴會廳，見證各式歡慶活動，正式的產品發表，或度假般的小型宴會會議，抑或喜氣滿滿的文定歡宴；若有相關需求，我們將根據人數、預算和使用目的提出建議，歡迎貴賓請隨時與我們聯繫。辦一場溫馨難忘的聚會。' }
        ];
    }
    else if (dataType === 'jsonData242') {
        return [
            { key: 1, name: '宴會廳線上預約登記' },
            { key: 2, name: '' }
        ];
    }
    else if (dataType === 'jsonData251') {
        return [
            { key: 1, name: '如何前往日勝生加賀屋？接駁/交通資訊' },
            { key: 2, name: '日勝生加賀屋座落於全世界唯一可以坐捷運抵達的溫泉區 – 台北市北投區。貴賓可以自行開車或是透過大眾運輸工具（台北捷運/公車）抵達。飯店亦提供捷運站至飯店的免費接駁，若有需求，歡迎來電預約。' }
        ];
    }
    else if (dataType === 'jsonData253') {
        return [
            { key: 1, name: '客房總覽 – 北投加賀屋' },
            { key: 2, name: '' }
        ];
    }
    else if (dataType === 'jsonData256') {
        return [
            { key: 1, name: '請參考2023 泡湯一日遊優惠套裝' },
            { key: 2, name: '' }
        ];
    }
    else if (dataType === 'jsonData257-1') {
        return [
            { key: 1, name: '◎【抓周宴 / 收涎宴】線上預約表單' },
            { key: 2, name: '' }
        ];
    }        
    else if (dataType === 'jsonData257-2') {
        return [
            { key: 1, name: '◎查看相關資訊' },
            { key: 2, name: '' }
        ];
    }    
};